
/**
 * React component representing the description section for "Hey Matic."
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for the component, including information for the "Hey Matic" description.
 * @returns {JSX.Element} React component.
 */
import React from "react";
import Number from "../Number";
import HeyMaticImageSection from "./HeyMaticImageSection";
import commonStyles from "../../../common/commonstyles.module.scss";
import Ticker from "../Ticker/Ticker";

export default function HeyMaticDescription({ data }) {
  return (
    <section className="w-full h-auto mt-[40px] lg:mt-[200px] md:pb-[100px] relative">
      <Number numberBgColors={"#FFE895"} numberText={"03"} />
      <div className="mt-[24px] lg:mt-[32px] relative mx-[16px]">
        <h2 className={`text-center text-primary pb-[16px] lg:pb-[16px]`}>
          Your home, your rules. Total control.
        </h2>
        <p
          className={`text-center text-primary lg:pb-[104px] max-w-[600px] m-auto`}
        >
          Matic cleans exactly how you like it. Prioritize rooms, target specific areas, or schedule a cleanup for after dinner—or while you sleep.
        </p>
      </div>

      <HeyMaticImageSection data={data} />

      <div className="relative bottom-0 left-0 mt-[16px] lg:mt-0 lg:absolute lg:bottom-[120px] lg:left-[calc(50%-320px)]">
        <Ticker data={data} />
      </div>
    </section>
  );
}
